import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '@shapeable/utils'; const cls = classNames('entity-link-button');
import { Classable, HasChildren, Entity, Shapeable } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { ArrowFullRightIconGlyph, DottedChevronLeftIconGlyph, DottedChevronRightIconGlyph } from '@shapeable/icons';

import { get } from 'lodash';
import { LinkButton, LinkButtonProps } from '@shapeable/ui';

// -------- Types -------->

export type EntityLinkButtonProps = Classable & HasChildren & Omit<LinkButtonProps, 'href'> & { 
  entity?: Entity;
  isBack?: boolean;
};

export const EntityLinkButtonDefaultProps: Omit<EntityLinkButtonProps, 'entity'> = {
  isBack: false,
};

// -------- Child Component Props -------->

type ContainerProps = {
  _backgroundColor?: string;
};

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
    max-width: 300px;

    .shp--button {
    
    ${({ _backgroundColor }: ContainerProps) => _backgroundColor && css`
      background: ${theme.COLOR(_backgroundColor)};
      border: none;
    `}
    color: white;
    font-weight: 600;
    padding: 12px 24px;
    transition: all 0.3s ease;
    
    &:hover {
      filter: brightness(1.1);
      transform: translateX(8px);
    }
    
    &:active {
      transform: translateY(0) translateX(8px);
    }
    }
  `,
});


// -------- Components -------->

const My = {
  Container: styled(LinkButton)<ContainerProps>`${ContainerStyles}`,
};

export const EntityLinkButton: Shapeable.FC<EntityLinkButtonProps> = (props) => {
  const { className, children, isBack, entity, ...rest } = props;

  const { color, path } = entity;
  
  const icon = isBack ? DottedChevronLeftIconGlyph : DottedChevronRightIconGlyph;
  
  const isDownload = !!get(entity, "isDownload");

  return (
    <My.Container 
      href={path} 
      _backgroundColor={color?.darkValue || color?.value || 'primary'}
      {...rest} 
      isDownload={isDownload} 
      icon={ArrowFullRightIconGlyph}
      colors={{ fill: 'light' }}
      className={cls.name(className)}
      >
    {children || entity.name}
    </My.Container>
  )
};

EntityLinkButton.defaultProps = EntityLinkButtonDefaultProps;
EntityLinkButton.cls = cls;